// 3_pages/delivery_and_payment.js
// On the deliveries-and-payments page, makes each .item expand/collapse on click.

export function init() {
	document.addEventListener("DOMContentLoaded", function () {
		deliveryAndPaymentPage();
	});
}

function deliveryAndPaymentPage() {
	const deliveriesAndPaymentsBlock = document.querySelector(".page-deliveries-and-payments");
	if (!deliveriesAndPaymentsBlock) return;

	const itemsToToggle = deliveriesAndPaymentsBlock.querySelectorAll(".item");
	if (!itemsToToggle || itemsToToggle.length === 0) return;
	itemsToToggle.forEach((item) => {
		window.NAT.utils.expandedToggle(item);
	});
}
